import React, {
  useState,
  useEffect
} from 'react';

import "../App.css";

import {
  message,
  Form,
  Input,
  InputNumber,
  Select,
  Button,
  Table
} from "antd"

import {
  db
} from '../firebase/firebase'
import { auth } from '../firebase';
import {
  SearchOutlined,
} from '@ant-design/icons';
import moment from 'moment';


const success = (x) => {
  message.success(x);
};

const error = () => {
  message.error('This is a message of error');
};

const load = (x) => {
  message.loading(x);
}

const Option2 = Select.Option;

// this.state = {
//   data: [],
//   major: [],
//   editingKey: '',
//   tempStatus: '',
//   ta: null,
//   xa: null,
//   ya: null,
//   sa: null,
//   ca: null,
//   email: ''
// };

const EditableCell = ({
  editing,
  dataIndex,
  title,
  inputType,
  record,
  index,
  children,
  ...restProps
}) => {
  const inputNode = inputType === 'number' ? <InputNumber /> : <Input />;
  return (
    <td {...restProps}>
      {editing ? (
        <Form.Item
          name={dataIndex}
          style={{
            margin: 0,
          }}
          rules={[
            {
              required: true,
              message: `Please Input ${title}!`,
            },
          ]}
        >
          {inputNode}
        </Form.Item>
      ) : (
        children
      )}
    </td>
  );
};

const Project = (props) => {
  useEffect(() => {
    pullFromDB()

    auth.onAuthStateChanged((user) => {
      if (user) {
        setEmail(user.email)
      }
    });
  }, []);

  const [form] = Form.useForm();
  const [data, setData] = useState([]);
  const [editingKey, setEditingKey] = useState('');

  const [email, setEmail] = useState('');
  const [tempStatus, setTempStatus] = useState('');

  const selector = (key, value) => {
    // data[key].isSold = value;
    setTempStatus(value)
  }

  const addProject = async () => {
    var na = moment()
    await db.collection("units").add({
      projects: props.match.params.id,
      unittype: "test",
      lot: "test",
      unitno: "test",
      size: "123",
      price: "123",
      customer: "test",
      outline: "-",
      date: na.toISOString(),
      isSold: "Open",
    });
  }







  const isEditing = (record) => record.key === editingKey;


  const edit = (record) => {
    var tempB = data[record.key].isSold
    console.log('ff')
    form.setFieldsValue({
      filename: '',
      startdate: '',
      ...record,
    });
    setEditingKey(record.key);
    setTempStatus(tempB)

  };

  const cancel = () => {
    setEditingKey('');
    // this.state.show = false

  };

  const save = async (key) => {
    if (!navigator.onLine)
      return

    try {
      const row = await form.validateFields();
      const newData = [...data];
      const index = newData.findIndex((item) => key === item.key);

      if (index > -1) {
        const item = newData[index];
        newData.splice(index, 1, { ...item, ...row });

        try {

          if (!/^-?\d*[.,]?\d{0,2}$/.test(newData[index].price)) {
            message.error('Numbers only. Decimal point is allowed.')
            return
          }
          load('Updating..', 0)
          newData[index].isSold = tempStatus

          await db
            .collection("units")
            .doc(data[index].id).update({
              unitno: newData[index].unitno,
              price: newData[index].price,
              customer: newData[index].customer,
              isSold: newData[index].isSold
            })
          success(
            'Successfully updated [Unit No: '
            + newData[index].unitno
            + '] [Price: '
            + newData[index].price
            + '] [Customer: '
            + newData[index].customer
            + '] [Status: '
            + newData[index].isSold
            + ']'
          )
          setData(newData)
          setEditingKey('');

        } catch (error) {
          message.error(error.message);
        }

      } else {
        newData.push(row);
        setData(newData);
        setEditingKey('');
      }
    } catch (errInfo) {
      console.log('Validate Failed:', errInfo);
    }
  }

  const getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({
      setSelectedKeys, selectedKeys, confirm, clearFilters,
    }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={node => { this.searchInput = node; }}
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
          onPressEnter={() => handleSearch(selectedKeys, confirm)}
          style={{ width: 188, marginBottom: 8, display: 'block' }}
        />
        <Button
          type="primary"
          onClick={() => handleSearch(selectedKeys, confirm)}
          size="small"
          style={{ width: 90, marginRight: 8 }}
        >
          Search
          </Button>
        <Button
          onClick={() => handleReset(clearFilters)}
          size="small"
          style={{ width: 90 }}
        >
          Reset
          </Button>
      </div>
    ),
    filterIcon: filtered => <SearchOutlined />,
    onFilter: (value, record) => record[dataIndex].toString().toLowerCase().includes(value.toLowerCase()),
    onFilterDropdownVisibleChange: (visible) => {
      if (visible) {
        setTimeout(() => this.searchInput.select());
      }
    },
    render: (text) => (
      text
    ),
  })
  const pullFromDB = () => {
    var baba;
    if (props.match.params.id) {
      baba = props.match.params.id
    }
    // We listen for live changes to our data collection in Firebase
    db.collection("units").where("projects", "==", baba).onSnapshot(snapshot => {
      //data is locally available array, pulled from firestore.
      let data = [];
      snapshot.forEach(doc => {
        const todo = doc.data();
        todo.id = doc.id;
        data.push(todo);
      });

      // Sort our data based on time added
      data.sort(function (a, b) {
        return (
          new Date(b.date).getTime() - new Date(a.date).getTime()
        );
      });

      //assign primary key
      for (var i = 0; i < data.length; i++) {
        data[i].key = i;
      }



      // Anytime the state of our database changes, we update state
      setData(data)

    })
  }


  const columns = [
    // {
    //   title: 'PK',
    //   dataIndex: 'key',
    //   width: '5%',
    //   editable: false,
    // },
    {
      title: 'Unit Type',
      dataIndex: 'unittype',
      ...getColumnSearchProps('unittype'),
      editable: false,
      sorter: (a, b) => { return a.unittype.localeCompare(b.unittype) },
    },
    {
      title: 'Lot',
      dataIndex: 'lot',
      ...getColumnSearchProps('lot'),
      editable: false,
      sorter: (a, b) => { return a.lot.localeCompare(b.lot) },
    },
    {
      title: 'Unit No.',
      dataIndex: 'unitno',
      ...getColumnSearchProps('unitno'),
      editable: true,
      sorter: (a, b) => { return a.unitno.localeCompare(b.unitno) },
    },
    {
      title: 'Size',
      dataIndex: 'size',
      ...getColumnSearchProps('size'),
      editable: false,
      sorter: (a, b) => parseInt(a.size, 10) - parseInt(b.size, 10),
      onHeaderCell: (column) => {
        return {
          onClick: () => {
            console.log('onClick');
          }
        };
      }
    },
    {
      title: 'Land Area',
      dataIndex: 'landarea',
      ...getColumnSearchProps('landarea'),
      editable: false,
      sorter: (a, b) => { return a.landarea.localeCompare(b.landarea) },
    },
    {
      title: 'Price',
      dataIndex: 'price',
      ...getColumnSearchProps('price'),
      editable: true,
      sorter: (a, b) => parseInt(a.price, 10) - parseInt(b.price, 10),
    },
    {
      title: 'Customer Name',
      dataIndex: 'customer',
      ...getColumnSearchProps('customer'),
      editable: true,
      sorter: (a, b) => a.customer.length - b.customer.length,
    },
    {
      title: 'Status',
      dataIndex: 'isSold',
      width: '9%',
      filters: [{
        text: 'Sold',
        value: 'Sold',
      }, {
        text: 'Open',
        value: 'Open',
      }],
      filterMultiple: false,
      onFilter: (value, record) => record.isSold.indexOf(value) === 0,
      render: (text, record) => {
        const editable = isEditing(record);

        return (
          <div>
            {editable ? (
              <div>
                <Select style={{ width: 120 }} defaultValue={data[record.key].isSold} onChange={(value) => selector(record.key, value)}>
                  <Option2 value="Open">Open</Option2>
                  <Option2 value="Sold">Sold</Option2>
                </Select>
              </div>
            ) : (
              <div>
                {data[record.key].isSold}
              </div>
            )}
          </div>
        );
      },
    },
    {
      title: '',
      width: '10%',
      dataIndex: 'operation',
      render: (_, record) => {
        const editable = isEditing(record);
        return editable ? (
          <span>
            <Button
              href=""
              onClick={e => {
                e.preventDefault()
                save(record.key)
              }}
              style={{
                marginRight: 8,
              }}
            >
              Save
          </Button>
            <Button type="primary" onClick={() => cancel(record.key)}>Cancel</Button>
          </span>
        ) : (
          <div>
            <Button disabled={editingKey !== ''} onClick={() => edit(record)}>
              Edit
        </Button>
          </div>
        );
      },
    },
  ];

  const handleSearch = (selectedKeys, confirm) => {
    confirm();
  }


  const handleReset = (clearFilters) => {
    clearFilters();
  }


  const exportFile = () => {
    if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
      error('This feature is only on PC.')
    } else {
      this.state.major = [];
      var i;
      for (i = 0; i < data.length; i++) {
        var lol = [
          data[i].id,
          data[i].projects,
          data[i].unittype,
          data[i].lot,
          data[i].unitno,
          data[i].size,
          data[i].price,
          data[i].customer,
          data[i].yy,
          data[i].xx,
          data[i].date,
          data[i].isSold
        ];
        this.state.major.push(lol)
      }

      // console.log(this.state.major)
      // alert("the string: " + this.state.major.toString())
      success('Downloading ' + this.state.major.length + " records...")
      if (this.state.major.length > 1)
        downloadcsv();
    }
  }

  const downloadcsv = (e) => {
    // console.log("heyy2 " + this.state.major);
    var csv = `doc_id,projects,unittype,lot,unitno,size,price,customer,yy,xx,date,isSold,\n`
    this.state.major.forEach(function (row) {
      csv += row.join(',');
      csv += "\n";
    });

    var hiddenElement = document.createElement('a');
    hiddenElement.href = 'data:text/csv;charset=utf-8,' + encodeURI(csv);
    hiddenElement.target = '_blank';
    hiddenElement.download = props.match.params.name + '.csv';
    hiddenElement.click();
  }

  const mergedColumns = columns.map((col) => {
    if (!col.editable) {
      return col;
    }

    return {
      ...col,
      onCell: (record) => ({
        record,
        inputType: col.dataIndex === 'price' ? 'text' : 'text',
        dataIndex: col.dataIndex,
        title: col.title,
        editing: isEditing(record),
      }),
    };
  });
  return (
    <div>
      <h1 className="block">{props.match.params.name}</h1>
      <div className="csvbtn" >
        <Button onClick={exportFile}>Export to CSV</Button>
      </div>
      {email === 'cc@cc.cc' ? <Button onClick={() => addProject()}>Add</Button> : <div />}

      <Form form={form} component={false}>
        <Table
          components={{
            body: {
              cell: EditableCell,
            },
          }}
          bordered
          dataSource={data}
          columns={mergedColumns}
          rowClassName="editable-row"
          pagination={true}
        />
      </Form>
    </div>
  );
};

export default Project;






// WEBPACK FOOTER //
// ./src/views/projects.js